import { createSlice } from '@reduxjs/toolkit';
import type { PermissionInterface, RolesInterface } from './types';
import type { ReduxBaseStateInterface } from '@/types/component';

export interface RolesStateInterface {
  roles: ReduxBaseStateInterface<RolesInterface[]>;
  permissions: ReduxBaseStateInterface<PermissionInterface[]>;
  addNewRole: ReduxBaseStateInterface<null>;
}

const stateTypes = ['roles', 'permissions'] as const;

const initialState = {
  addNewRole: {
    data: null,
    loading: false,
    error: false,
    cached: false,
    message: '',
  },
} as RolesStateInterface;
stateTypes.forEach((type) => {
  initialState[type] = {
    data: [],
    loading: false,
    error: false,
    cached: false,
    message: '',
  };
});

export const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    startLoading: (state, action) => {
      const type: keyof RolesStateInterface = action.payload;
      state[type].loading = true;
    },
    stopLoading: (state, action) => {
      const type: keyof RolesStateInterface = action.payload.type;
      const error = action.payload?.error || true;
      state[type].loading = false;
      if (error) {
        state[type].cached = true;
        state[type].data = initialState[type].data;
      }
    },
    saveFetchedData: (state, action) => {
      const type: keyof RolesStateInterface = action.payload.type;
      state[type].loading = false;
      state[type].data = action.payload.data;
      state[type].error = false;
      state[type].cached = true;
    },
    dataFetchedWithError: (state, action) => {
      const type: keyof RolesStateInterface = action.payload.type;
      state[type].loading = false;
      state[type].error = true;
      state[type].cached = true;
      state[type].message = action.payload.message;
    },
    clearData: (state, action) => {
      const type: keyof RolesStateInterface = action.payload;
      state[type].data = initialState[type].data;
      state[type].cached = false;
      state[type].error = false;
      state[type].message = '';
      state[type].loading = false;
    },
    resetRoleSlice: () => initialState,
  },
});

export const rolesActions = rolesSlice.actions;

export const rolesReducer = rolesSlice.reducer;
